import {createStackNavigator} from '@react-navigation/stack';
import React, {useEffect} from 'react';
import {useTheme} from 'styled-components';

import {AppTabNav} from './app.tab.routes';
import {IdpayVerificationProvider} from '../context/IdpayVerification';

import {Coupon as CouponNovo} from '../screens/CouponNovo';

import {Product} from '../screens/Product';

import {Localization} from '../screens/Localization';
import {ListagemPostos} from '../screens/Localization/ListagemPostos';
import {SubRegions} from '../screens/Localization/SubRegions';

import {Help} from '../screens/Help';
import {Chat} from '../screens/Help/Chat';
import {Account} from '../screens/User/Account';

import {PaymentsHistory} from '../screens/User/PaymentsHistory';

import {Payment} from '../screens/Payment';
import {Pix} from '../screens/Payment/Pix';

import {Discount} from '../screens/Payment/Discount';
import {Payment as PaymentNovo} from '../screens/Payment';
import {Pix as PixNovo} from '../screens/Payment/Pix';

import {Discount as DiscountNovo} from '../screens/Payment/Discount';

import {Station} from '../screens/Station';
import {User} from '../screens/User';

import {DeleteAccount} from '../screens/User/Account/DeleteAccount';

import {AddCreditCard} from '../screens/CardsWallet/AddCreditCard';
import {EditCreditCardAddress} from '../screens/CardsWallet/EditCreditCardAdress';
import {CardWalletInfo} from '../screens/CardsWallet/CardWalletInfo';

import {ConfirmationScreen} from '../screens/ConfirmationScreen';

import {EmprestimoSimulacao} from '../screens/Emprestimo/Simulacao';
import {EmprestimoSimulacaoResultado} from '../screens/Emprestimo/SimulacaoResultado';
import {EmprestimoEndereco} from '../screens/Emprestimo/Endereco';
import {EmprestimoDomicilio} from '../screens/Emprestimo/Domicilio';
import {DocumentosIntro as EmprestimoDocumentosIntro} from '../screens/Emprestimo/DocumentosIntro';
import {EmprestimoTipoDocumento} from '../screens/Emprestimo/TipoDocumento';
import {Selfie as EmprestimoDocumentos} from '../screens/Emprestimo/Selfie';
import {ConfirmacaoProposta as EmprestimoConfirmacaoProposta} from '../screens/Emprestimo/ConfirmacaoProposta';
import {Assinatura as EmprestimoAssinatura} from '../screens/Emprestimo/Assinatura';

import {
  EmprestimosGateway,
  SimularGateway,
} from '../screens/Emprestimo/DeeplinkGateway';
import {EmprestimoPagamento} from '../screens/Emprestimo/Pagamento';

import {AcceptCreditCardRegulament} from '../screens/CardsWallet/AcceptCreditCardRegulament';
import {UserCreditCardNotEligible} from '../screens/CardsWallet/UserCreditCardNotEligible';
import {CouponStationsNovo} from '../screens/CouponNovo/CouponStations';

import {HelpArticle} from '../screens/Help/HelpArticle';

import {ReferAndWin} from '../screens/ReferAndWin';
import {BaratinhasHistory} from '../screens/User/BaratinhasHistory';
import {Checkin} from '../screens/User/Checkin';
import {Beneficios} from '../screens/Beneficios';

import {ChangePassword} from '../screens/ChangePassword';

import {CardsWallet} from '../screens/CardsWallet';
import {HowTo} from '../screens/Clube/HowTo';
import {Tutoriais} from '../screens/Tutoriais';
import {Store} from '../screens/Clube/Store';
import {Fipe} from '../screens/Fipe';
import {FipeDetails} from '../screens/Fipe/Details';
import {LoadingFipe} from '../screens/Fipe/Loading';
import {Fuel} from '../screens/Fuel';

import {Stations} from '../screens/Stations';

import {Limites} from '../screens/Limites';
import {PlacaVeiculo} from '../screens/Product/PlacaVeiculo';
import {AutEstampagem} from '../screens/Product/AutEstampagem';
import {Vigilante} from '../screens/Vigilante';

import {PP_Debits} from '../screens/ProntoPaguei/VehicleDebits/Debits';

import {PP_Checkout} from '../screens/ProntoPaguei/VehicleDebits/Checkout';

import {PP_TrackRequests} from '../screens/ProntoPaguei/VehicleDebits/TrackRequests';
import {PP_TrackRequestDetail} from '../screens/ProntoPaguei/VehicleDebits/TrackRequestDetail';
import {LoadingClube} from '../screens/Clube/Loading';
import {ReferAndWinUsers} from '../screens/ReferAndWin/Users';
import {Products} from '../screens/Products';
import {ReferAndWinUsersDesactivated} from '../screens/ReferAndWin/Users/Desactivated';
import {ListLocations} from '../screens/ListLocations';
import {ReferAndWinUsersInfo} from '../screens/ReferAndWin/Users/Info';

import {Vehicles} from '../screens/Vehicles';
import {AddVehicle} from '../screens/Vehicles/AddVehicle';

import {Vehicle} from '../screens/Vehicles/Vehicle';
import {OnboardingFeatures} from '../screens/Onboarding/OnboardingFeatures';
import {api} from '../services/api';
import {useNavigation} from '@react-navigation/native';
import {useAuth} from '../context/auth';
import {StationsMap} from '../screens/StationsMap';
import {MapLocation} from '../screens/StationsMap/Location';
import {SubRegionsMap} from '../screens/StationsMap/Location/SubRegions';
import {Reembolsos} from '../screens/Reembolsos';
import {DadosBancarios} from '../screens/Reembolsos/DadosBancários';
import {ConfirmaReembolso} from '../screens/Reembolsos/ConfirmaReembolso';
import {SolicitaReembolso} from '../screens/Reembolsos/SolicitaReembolso';
import {PedidosReembolso} from '../screens/Reembolsos/Pedidos';
import {BaratinhasAjuda} from '../screens/BaratinhasAjuda';
import {Roulette} from '../screens/Roulette';
import {UnitsDetails} from '../screens/Clube/Store/Units/UnitsDetails';
import {StoreFiltersNeighborhood} from '../screens/Clube/Search/Filters/Bairro';
import {StoreFiltersCities} from '../screens/Clube/Search/Filters/Cidade';
import {StoreFiltersState} from '../screens/Clube/Search/Filters/Estado';
import {StoreFiltersCategory} from '../screens/Clube/Search/Filters/Categoria';
import {StoreSearchFilters} from '../screens/Clube/Search/Filters';
import {StoreUnits} from '../screens/Clube/Store/Units';
import {StoreSearch} from '../screens/Clube/Search';
import {Clube} from '../screens/Clube';
import {ClubeNotEligible} from '../screens/Clube/NotElegible';
import {Achievements} from '../screens/User/Achievements';

const {Navigator, Screen} = createStackNavigator();

export function AppStackNav() {
  const theme = useTheme();
  const {signOut, openSign, setSessionExpired} = useAuth();

  const options = {
    headerShown: false,
    cardStyle: {backgroundColor: theme.colors.background},
  };

  const navigation = useNavigation();

  useEffect(() => {
    const interceptor = api.interceptors.response.use(
      response => {
        // Retorna a resposta normalmente para requisições bem-sucedidas
        return response;
      },
      async error => {
        if (
          error.response?.status === 401 &&
          error.response?.data?.message === 'Token expired'
        ) {
          await signOut(); // Desloga o usuário

          navigation.navigate('Initial');
          setSessionExpired(true);
          openSign();
        }
        return Promise.reject(error); // Retorna o erro para ser tratado pela chamada original, se necessário
      },
    );

    return () => {
      api.interceptors.response.eject(interceptor); // Remove o interceptor ao desmontar
    };
  }, []);

  return (
    <IdpayVerificationProvider>
      <Navigator screenOptions={options} initialRouteName={'Home'}>
      <Screen
        name="Home"
        component={AppTabNav}
        options={{gestureEnabled: false, animationEnabled: false}}
      />
      <Screen
        name="Vigilante"
        component={Vigilante}
        options={{gestureEnabled: true}}
      />
      <Screen name="Fipe" component={Fipe} options={{gestureEnabled: true}} />
      <Screen
        name="LoadingFipe"
        component={LoadingFipe}
        options={{gestureEnabled: false}}
      />
      <Screen
        name="FipeDetails"
        component={FipeDetails}
        options={{gestureEnabled: false}}
      />

      <Screen name="User" component={User} />
      <Screen
        name="Localization"
        //@ts-ignore
        component={Localization}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="SubRegions"
        //@ts-ignore
        component={SubRegions}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="LoadingClube"
        component={LoadingClube}
        options={{gestureEnabled: false}}
      />
      <Screen
        name="ListagemPostos"
        //@ts-ignore
        component={ListagemPostos}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="Products"
        component={Products}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="CardsWallet"
        component={CardsWallet}
        options={{gestureEnabled: true}}
      />

      <Screen
        name="Station"
        component={Station}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="Stations"
        component={Stations}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="CardWalletInfo"
        component={CardWalletInfo}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="ReferAndWin"
        component={ReferAndWin}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="ReferAndWinUsers"
        component={ReferAndWinUsers}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="ReferAndWinUsersDesactivated"
        component={ReferAndWinUsersDesactivated}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="ReferAndWinUsersInfo"
        component={ReferAndWinUsersInfo}
        options={{gestureEnabled: true}}
      />
      <Screen name="Fuel" component={Fuel} options={{gestureEnabled: true}} />

      <Screen
        name="Product"
        component={Product}
        options={{gestureEnabled: true}}
      />

      <Screen
        name="PlacaVeiculo"
        component={PlacaVeiculo}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="AutEstampagem"
        component={AutEstampagem}
        options={{gestureEnabled: true}}
      />

      {/**FLUXO PAGAMENTO ANTIGO (VALIDADO) */}
      <Screen
        name="Payment"
        component={Payment}
        options={{gestureEnabled: false}}
      />
      <Screen
        name="Discount"
        component={Discount}
        options={{gestureEnabled: true}}
      />
      <Screen name="Pix" component={Pix} options={{gestureEnabled: false}} />

      {/**FLUXO PAGAMENTO NOVO (NAO VALIDADO) */}
      <Screen
        name="PaymentNovo"
        component={PaymentNovo}
        options={{gestureEnabled: false}}
      />
      <Screen
        name="DiscountNovo"
        component={DiscountNovo}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="PixNovo"
        component={PixNovo}
        options={{gestureEnabled: false}}
      />

      <Screen
        name="AddCreditCard"
        component={AddCreditCard}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="EditCreditCardAddress"
        component={EditCreditCardAddress}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="UserCreditCardNotEligible"
        component={UserCreditCardNotEligible}
        options={{gestureEnabled: false}}
      />
      <Screen
        name="AcceptCreditCardRegulament"
        component={AcceptCreditCardRegulament}
        options={{gestureEnabled: false}}
      />
      <Screen
        name="Account"
        component={Account}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="Vehicles"
        component={Vehicles}
        options={{gestureEnabled: false}}
      />
      <Screen
        name="Vehicle"
        component={Vehicle}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="AddVehicle"
        component={AddVehicle}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="DeleteAccount"
        component={DeleteAccount}
        options={{gestureEnabled: true}}
      />

      <Screen name="Help" component={Help} options={{gestureEnabled: true}} />
      <Screen name="Chat" component={Chat} options={{gestureEnabled: true}} />
      <Screen
        name="HelpArticle"
        component={HelpArticle}
        options={{gestureEnabled: true}}
      />

      <Screen
        name="PaymentsHistory"
        component={PaymentsHistory}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="BaratinhasHistory"
        component={BaratinhasHistory}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="Checkin"
        component={Checkin}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="Beneficios"
        component={Beneficios}
        options={{gestureEnabled: true}}
      />

      <Screen
        name="PP_Debits"
        component={PP_Debits}
        options={{gestureEnabled: false}}
      />

      <Screen
        name="PP_Checkout"
        component={PP_Checkout}
        options={{gestureEnabled: false}}
      />

      <Screen
        name="PP_TrackRequests"
        component={PP_TrackRequests}
        options={{gestureEnabled: true}}
      />

      <Screen
        name="PP_TrackRequestDetail"
        component={PP_TrackRequestDetail}
        options={{gestureEnabled: true}}
      />

      <Screen
        name="ConfirmationScreen"
        component={ConfirmationScreen}
        options={{gestureEnabled: false}}
      />

      <Screen
        name="EmprestimoSimulacao"
        component={EmprestimoSimulacao}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="EmprestimoSimulacaoResultado"
        component={EmprestimoSimulacaoResultado}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="EmprestimoEndereco"
        component={EmprestimoEndereco}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="EmprestimoDomicilio"
        component={EmprestimoDomicilio}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="EmprestimoDocumentosIntro"
        component={EmprestimoDocumentosIntro}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="EmprestimoTipoDocumento"
        component={EmprestimoTipoDocumento}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="EmprestimoDocumentos"
        component={EmprestimoDocumentos}
        options={{gestureEnabled: false}}
      />
      <Screen
        name="EmprestimoConfirmacaoProposta"
        component={EmprestimoConfirmacaoProposta}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="EmprestimoAssinatura"
        component={EmprestimoAssinatura}
        options={{gestureEnabled: true}}
      />

      <Screen
        name="EmprestimoPagamento"
        component={EmprestimoPagamento}
        options={{gestureEnabled: true}}
      />

      <Screen
        name="CouponNovo"
        component={CouponNovo}
        options={{gestureEnabled: true}}
      />

      <Screen
        name="CouponStationsNovo"
        component={CouponStationsNovo}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="ChangePassword"
        component={ChangePassword}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="Roulette"
        component={Roulette}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="Store"
        component={Store}
        options={{gestureEnabled: false}}
      />
      <Screen name="HowTo" component={HowTo} options={{gestureEnabled: true}} />
      <Screen
        name="Tutoriais"
        component={Tutoriais}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="Limites"
        component={Limites}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="ListLocations"
        component={ListLocations}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="OnboardingFeatures"
        component={OnboardingFeatures}
        options={{gestureEnabled: false}}
      />

      <Screen
        name="MapLocation"
        //@ts-ignore
        component={MapLocation}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="SubRegionsMap"
        //@ts-ignore
        component={SubRegionsMap}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="Reembolsos"
        //@ts-ignore
        component={Reembolsos}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="DadosBancarios"
        //@ts-ignore
        component={DadosBancarios}
        options={{gestureEnabled: true}}
      />
      <Screen
        //@ts-ignore
        name="ConfirmaReembolso"
        //@ts-ignore
        component={ConfirmaReembolso}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="SolicitaReembolso"
        //@ts-ignore
        component={SolicitaReembolso}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="PedidosReembolso"
        //@ts-ignore
        component={PedidosReembolso}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="BaratinhasAjuda"
        //@ts-ignore
        component={BaratinhasAjuda}
        options={{gestureEnabled: true}}
      />

      <Screen
        name="ClubeNotEligible"
        component={ClubeNotEligible}
        options={{gestureEnabled: false}}
      />
      <Screen
        name="Clube"
        component={Clube}
        options={{gestureEnabled: false}}
      />
      <Screen
        name="StoreSearch"
        component={StoreSearch}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="StoreUnits"
        component={StoreUnits}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="StoreSearchFilters"
        component={StoreSearchFilters}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="StoreFiltersCategory"
        component={StoreFiltersCategory}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="StoreFiltersState"
        component={StoreFiltersState}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="StoreFiltersCities"
        component={StoreFiltersCities}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="StoreFiltersNeighborhood"
        component={StoreFiltersNeighborhood}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="UnitsDetails"
        component={UnitsDetails}
        options={{gestureEnabled: true}}
      />

      <Screen
        name="Emprestimos"
        component={EmprestimosGateway}
        options={{gestureEnabled: false, animationEnabled: false}}
      />
      <Screen
        name="Simular"
        component={SimularGateway}
        options={{gestureEnabled: false, animationEnabled: false}}
      />
      <Screen
        name="StationsMap"
        component={StationsMap}
        options={{gestureEnabled: false}}
      />
      <Screen
        name="Achievements"
        component={Achievements}
        options={{gestureEnabled: true}}
      />
      </Navigator>
    </IdpayVerificationProvider>
  );
}
